import { Component, OnInit } from '@angular/core';
import { UiProfileService } from '../../services/ui-profile.service';


@Component({
  selector: 'bi-favorite-button',
  standalone: false,
  templateUrl: './bi-favorite-button.component.html',
  styleUrl: './bi-favorite-button.component.scss'
})
export class BIFavoriteButtonComponent implements OnInit {

  selected: boolean = false;

  constructor(
    private uiProfileService: UiProfileService
  ){}

  ngOnInit(): void {
    if(this.uiProfileService.IsUserUIProfileFilled)
      this.selected = this.uiProfileService.UserUIProfile.IsCurrentScreenFavorite;
    else{
      let sub = this.uiProfileService.UserUIProfileFilled$
      .subscribe(
        _ => {
          this.selected = this.uiProfileService.UserUIProfile.IsCurrentScreenFavorite;
          sub.unsubscribe();
        }
      )
    }
        
  }
  public toggleSelected() {
    this.selected = !this.selected;
    this.uiProfileService.emitfavoriteScreenChanged(this.selected);
  }
}
